module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0ace6d0c800d1275dc415b967ff1dcc4.png";